import styled from "styled-components";

export const ProfileDropDownItems = styled.ul`
  padding: 0;
  margin: 0;
  list-style-type: none;
  
  a.active {
    background-color: #F8F9FA;
    
    i::before {
      color: var(--success-color);
    }
    
    i+p {
      color: var(--dark-gray-color);
    }
  }
`;

export const ProfileDropDownItem = styled.li`
  border-radius: 10px;
  overflow: hidden;
  transition: .3s;
  
  a, button {
    display: flex;
    align-items: center;
    padding: .7rem;
  }
  
  button {
    background-color: transparent;
    border: none;
    width: 100%;
  }
  
  &:not(:last-child) {
    margin-bottom: 1rem;
  }
  
  &:last-child {
    margin-top: 2.5rem;  
  }
  
  &:hover {
    background-color: #F8F9FA;
  }
  
  p {
    margin-bottom: 0;
    color: ${props => props.color ? props.color :  'var(--light-gray-color)' }
  }
  
  i {
    margin-left: .7rem;  
  }
  
  i:before {
    font-size: 1.3rem;
    color: ${props => props.color ? props.color :  'var(--light-gray-color)' };
  }

  @media (max-width: 1240px) and (min-width: 992px) {
    p {
      font-size: .8rem;
    }
  }
`;

export const ProfileDropDownDesc = styled.p`
  color: var(--sky-blue);
  font-size: .9rem;
  margin-right: 1.5rem;
`;

export const ProfileDropDownBadge = styled.div`
  margin-right: auto;
  width: 15px;
  height: 15px;
  background-color: var(--warning-color);
  border-radius: 50%;
`;
